import React from 'react';
import { useDataPresentationParam } from '@/hooks';
import { TABLE } from '@/components/charting/chartType.constants';
import { useNavigateToDataPresentation } from '@/features/dataPresentation/navigation/router-buttons/useNavigateToDataPresentation';
import { Table as TableBase } from '../buttons';

export const Table = () => {
  const dataPresentation = useDataPresentationParam();
  const navigate = useNavigateToDataPresentation(TABLE);

  return <TableBase $active={dataPresentation === TABLE} onClick={navigate} />;
};
